// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Btz8","nameContainer":"WyDDO","name":"zMb8-","removeLink":"_2alfR"};